/* eslint-disable import/no-anonymous-default-export */
export default {
  title: "AVITI Telemetry",
};
